/**
 * @name setCreateSpan
 */
export function setCreateSpan() {
    let Span = document.querySelectorAll('.--js_createSpan');
    for (let i = 0; i < Span.length; i++) {
        let SpanContent = Span[i].textContent;
        let text = SpanContent.trim();
        let newHtml = "";
        text.split("").forEach(function (v) {
            newHtml += "<span>" + v + "</span>";
        });
        Span[i].innerHTML = newHtml;
    }
    Span.forEach((span) => span.classList.remove('--js_createSpan'));
}